import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TMSService } from '../../core/service/tms/tms.service';
import { LocalStorageService } from '../../core/service/localStorage/local-storage.service';

/**
 * Attach this guard to every protected route (or to the dashboard parent).
 * If the user has not yet started their day, redirect them back to /start-day.
 */
export const startDayGuard: CanActivateFn = () => {
  const tmsService = inject(TMSService);
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  
  const user = localStorageService.getUser();
  
  if (user?.email === 'automation@crizac.com') {
    return true;
  }

  if (!tmsService.dayStarted) {
    router.navigate(['/start-day']);
    return false;
  }

  return true;
};